<template>
    <div>
        <v-card-actions>
            <v-container>
                <v-row>
                    <v-col cols="2">
                        <v-select
                            class="mr-3 pt-4"
                            :items="golfCourses"
                            item-value="golf_code"
                            item-text="golf_name"
                            v-model="golfCode"
                            label="ゴルフ場名"
                        ></v-select>
                    </v-col>
                    <v-col cols="2" align-self="center">
                        <v-btn
                            :disabled="btn[1].isActive"
                            color="primary"
                            dark
                            class=""
                            v-on:click="clickSearch">検索</v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-actions>
        <v-data-table
            :headers="headers"
            :items="desserts"
            hide-default-footer
            class="col-12"
            disable-pagination
            :fixed-header="true"
        >
            <template v-slot:[`item.term`]="{ item }">
                {{ item.play_date_start }} ～ {{ item.play_date_valid }}
            </template>
            <template v-slot:[`item.play_time_start`]="{ item }">
                {{ formatTimeString(item.play_time_start)}}
            </template>
            <template v-slot:[`item.play_time_valid`]="{ item }">
                {{ formatTimeString(item.play_time_valid)}}
            </template>
            <template v-slot:[`item.btn_edit`]="{ item }">
                <v-btn
                    :disabled="btn[3].isActive"
                    text
                    color="primary"
                    @click="editModalOpen(item.id)">編集</v-btn>
            </template>
            <template v-slot:[`item.btn_delete`]="{ item }">
                <v-btn
                    :disabled="btn[4].isActive"
                    text
                    color="primary"
                    @click="deleteModalOpen(item.id)">削除</v-btn>
            </template>
        </v-data-table>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                :disabled="btn[2].isActive"
                color="green darken-4"
                text
                @click="addModalOpen()">追加</v-btn>
        </v-card-actions>
        <CellBase
            :golfCourses="golfCourses"
            :id="id"
            :modal="modal"
            :golfCode="golfCode"
            :modeStatus="childModeStatus"
            @refresh-event="closeModal()"
        />
        <RemoveOverlay
            @processing="deleteCellBases()"
            @cancel="deleteOverlayClose()"
            :processResult="process"
            :OverlaySwitch="removeOverlay"
            pageName="基本枠"
        />
    </div>
</template>

<script>
// 画面
import CellBase from '@/views/System/page/modal/CellBase';
import RemoveOverlay from '@/components/overlay/RemoveOverlay';

// mixins
import { authorityMixin } from '@/views/authorityMixin';
import { golfCourseMixin } from '@/mixins/golfCourse';

// graphql
import {
    GET_CELL_BASES,
    DELETE_CELL_BASES
} from '@/constants/cell_bases';

export default {
    components: {
        CellBase,
        RemoveOverlay
    },
    mixins: [
        authorityMixin,
        golfCourseMixin
    ],
    data () {
        return {
            golfGroupCode: process.env.VUE_APP_GROUP_CODE,
            // 検索値
            golfCode: '',
            // セレクトボックス
            golfCourses: [],
            // 子コンポーネントID
            id: null,
            // 削除時のID
            deleteId: null,
            // 子画面の表示状態
            modal: false,
            // 子画面の編集状態 0:追加 1:編集
            childModeStatus: '',
            // v-data-tableのヘッダー
            headers: [
                { text: 'コース', value: 'course_name', sortable: false },
                { text: '期間', value: 'term', sortable: false },
                { text: '開始時刻', value: 'play_time_start', sortable: false, width: 200 },
                { text: '終了時刻', value: 'play_time_valid', sortable: false, width: 200 },
                { text: '間隔', value: 'dispInterval', sortable: false, width: 100 },
                { text: '', value: 'btn_edit', sortable: false, width: 200 },
                { text: '', value: 'btn_delete', sortable: false, width: 200 }
            ],
            // v-data-table データ
            desserts: [],
            // 削除ダイアログの状態
            removeOverlay: false,
            // 削除処理結果
            process: {
                // 処理結果
                result: '',
                // 処理結果メッセージ
                resultText: '',
                // 処理中かどうか
                processing: false
            },
            // ボタンの活性・非活性
            btn: [
                { element_id: '000', element_name: '画面', isActive: true },
                { element_id: '001', element_name: '検索', isActive: true },
                { element_id: '002', element_name: '追加', isActive: true },
                { element_id: '003', element_name: '編集', isActive: true },
                { element_id: '004', element_name: '削除', isActive: true }
            ],
            // operationID
            vue_id: 'SCR0034'
        };
    },
    created () {
        this.Initialize();
    },
    methods: {
        /** ----------------------------------------------
         * 初期化処理
         * ---------------------------------------------- */
        async Initialize () {
            this.admin = await this.getLoginAdmin();
            await this.getAuthorityList();
            this.golfCourses = await this.getGolfCourseList();
            this.golfCode = this.golfCourses[0].golf_code;
            this.getData();
        },
        /** ----------------------------------------------
         * 検索処理
         * ---------------------------------------------- */
        clickSearch () {
            this.getData();
        },
        /** ----------------------------------------------
         * 一覧データを取得
         * ---------------------------------------------- */
        getData () {
            try {
                this.$store.commit('loading/setIsLoading', true);
                this.$apollo.query({
                    query: GET_CELL_BASES,
                    fetchPolicy: 'no-cache',
                    variables: {
                        golf_group_code: this.golfGroupCode,
                        golf_code: this.golfCode
                    }
                }).then(res => {
                    this.desserts = res.data.getCellBases.CellBases;
                    for (var i = 0; i < this.desserts.length; i++) {
                        const str = JSON.parse(JSON.stringify(this.desserts[i].interval));
                        const obj = JSON.parse(str);
                        this.desserts[i].dispInterval = obj[0];
                    }
                });
                this.$store.commit('loading/setIsLoading', false);
            } catch (error) {
                this.resultText = error;
                this.$store.commit('loading/setIsLoading', false);
            }
        },
        /** ----------------------------------------------
         * 追加画面を開く。
         * ---------------------------------------------- */
        addModalOpen () {
            this.id = '';
            this.childModeStatus = '追加';
            this.modal = true;
        },
        /** ----------------------------------------------
         * 編集画面を開く。
         * ---------------------------------------------- */
        editModalOpen (id) {
            this.id = id;
            this.childModeStatus = '変更';
            this.modal = true;
        },
        /** ----------------------------------------------
         * 追加・編集画面を閉じる。
         * ---------------------------------------------- */
        closeModal () {
            this.id = null;
            this.childModeStatus = '';
            this.modal = false;
            this.getData();
        },
        /** ----------------------------------------------
         * 削除処理
         * ---------------------------------------------- */
        deleteCellBases () {
            this.$store.commit('loading/setIsLoading', true);
            this.$apollo.mutate({
                mutation: DELETE_CELL_BASES,
                variables: {
                    id: this.deleteId
                }
            }).then(res => {
                this.result = res.data.deleteCellBases.result;
                this.deleteOverlayClose();
                this.$store.commit('loading/setIsLoading', false);
                this.getData();
            }).catch(e => {
                this.result = e;
                this.resultText = e;
                this.$store.commit('loading/setIsLoading', false);
            });
        },
        /** ----------------------------------------------
         * 削除ダイアログを開く。
         * ---------------------------------------------- */
        deleteModalOpen (id) {
            this.deleteId = id;
            this.removeOverlay = true;
        },
        /** ----------------------------------------------
         * 削除ダイアログを閉じる。
         * ---------------------------------------------- */
        deleteOverlayClose () {
            this.deleteId = null;
            this.removeOverlay = false;
            this.result = 0;
            this.resultText = '';
        },
        /** ----------------------------------------------
         * 時間フォーマット
         * 例 07:00:00 → 0700
         * ---------------------------------------------- */
        formatTimeString (item) {
            return item.split(':').splice(0, 2).join(':');
        }
    }
};
</script>

<style scoped>
    .v-data-table{
        overflow-y: scroll;
        min-height: 200px;
        max-height: 600px;
    }
</style>
